import { ModuleWithProviders, isDevMode } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { HisBootstrapService } from '../service/base/his-bootstrap.service';
import { hisCanActivate } from './his-canactivate';
import { hisCanDeactivate } from './his-candeactivate';

/**
 * creates a router module for the root of the application
 * @deprecated use hisRoutes for standalone routes
 */
export function hisRootRoutes( routes: Routes, config?: ExtraOptions ): ModuleWithProviders<RouterModule> {
    const defaultConfig: ExtraOptions = { scrollPositionRestoration: 'enabled' };
    const mergedConfig: ExtraOptions = config ? { ...defaultConfig, ...config } : defaultConfig;
    return RouterModule.forRoot( hisRoutes( routes ), mergedConfig );
}

/**
 * creates a router module for child modules
*  @deprecated use hisRoutes for standalone routes
 */
export function hisChildRoutes( routes: Routes ): ModuleWithProviders<RouterModule> {
    return RouterModule.forChild( hisRoutes( routes ) );
}

export function hisRoutes( routes: Routes ): Routes {
    for ( let route of routes ) {

        route.resolve = {
            ...( route.resolve || {} ),
            boot: HisBootstrapService
        };

        // add guard for authentication and module-check
        if ( route.component || ( route.data && ( route.data.hasAll || route.data.hasAny ) ) ) {
            if ( route.canActivate ) {
                route.canActivate = [...route.canActivate, hisCanActivate];
            } else {
                route.canActivate = [hisCanActivate];
            }
        }

        // add warning about unsaved changes
        if ( route.component ) {
            if ( route.canDeactivate ) {
                route.canDeactivate = [...route.canDeactivate, hisCanDeactivate];
            } else {
                route.canDeactivate = [hisCanDeactivate];
            }
        }

        // recurse into static non-lazy child-routes
        if ( route.children ) {
            hisRoutes( route.children );
        }

        // workaround for Vite not being able to handle "." in path
        // https://github.com/angular/angular/issues/56211
        if ( route.path && route.path.indexOf( '.' ) > -1 && isDevMode() ) {
            let clone = Object.assign( {}, route );
            clone.path = route.path.replace( /\./g, '___' );
            routes.push( clone );
        }
    }
    return routes;
}
